import {Component} from '@angular/core';
import {ProcessingClassSubType} from '../../../../types/types';

@Component({
  selector: 'app-case-pharmacy-view',
  templateUrl: './case-pharmacy-view.component.html',
  styleUrls: []
})
export class CasePharmacyComponent {
  readonly processingClassSubType = ProcessingClassSubType;
}
